/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateNeighborhoodsVisibilityPauseStatusRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {UpdateNeighborhoodsVisibilityPauseStatusResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const updateNeighborhoodsVisibilityPauseStatus = (request: UpdateNeighborhoodsVisibilityPauseStatusRequest, options?: CashRequestOptions) => post<UpdateNeighborhoodsVisibilityPauseStatusRequest, UpdateNeighborhoodsVisibilityPauseStatusResponse>("/2.0/cash/update-neighborhoods-visibility-pause-status", request, {...options, rejectOnError: true })